<template>
    <div class="container p-0" v-if="hasQuote">
        <div style="background-color: #141414;" class="text-white text-center px-4 py-2 mx-2 cursor-pointer" @click="openModal">
            <p class="m-0 fs-8">{{ displayText.substring(0, 50) }}...</p>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'qoute'
    ],
    computed: {
        displayText() {
            return this.qoute?.code?.text || this.qoute?.text || '';
        },
        // When inspirational quotes are disabled for a location, the API
        // returns {"output":{"code":[]}}. Don't render the label/pop-up in
        // that case.
        hasQuote() {
            if (this.qoute && this.qoute.code) {
                if (Array.isArray(this.qoute.code)) return false;
                if (this.qoute.code && this.qoute.code.text) return true;
            }
            return Boolean(this.qoute && this.qoute.text);
        }
    }
}
</script>
